// Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import awsImage from "./images/aws.png";
import azureImage from "./images/azure.png";
import gc2Image from "./images/GCP.png";
import logo from "./images/disaster-logo.png";
import { useCloudProvider } from "./context/CloudProviderContext";

const Login = () => {
  const [selectedCloud, setSelectedCloud] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { setProvider } = useCloudProvider();


  const cloudOptions = [
    { name: "AWS", imgSrc: awsImage },
    { name: "Azure", imgSrc: azureImage },
    { name: "GCP", imgSrc: gc2Image },
  ];

 const handleSelectCloud = (cloudName) => {
    const cloud = cloudOptions.find((c) => c.name === cloudName);
    setSelectedCloud(cloud);
    localStorage.setItem("provider", cloudName);
    setProvider(cloudName);
    // Pass the cloud directly — state updates are async, so selectedCloud
    // would still hold the previous value if read here.
    redirectToCloud(cloud);
  };
 
  const redirectToCloud = (cloud) => {
    if (!cloud) return;
 
    if (cloud.name === "Azure") {
      handleAzureLogin();
    } else if (cloud.name === "AWS" || cloud.name === "GCP") {
      sessionStorage.setItem("isAuthenticated", "true");
      navigate("/dashboard");
    } else {
      setShowModal(true);
    }
  };

  const handleAzureLogin = () => {
    instance
      .loginPopup({ scopes: ["User.Read"] })
      .then(() => {
        sessionStorage.setItem("isAuthenticated", "true");
        navigate("/dashboard");
      })    
      .catch((error) => {
        console.error("Azure login failed:", error);
      });  
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Logging in to ${selectedCloud.name} with username: ${username}`);
    setShowModal(false);
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-image">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6"></div>
          <div className="col-md-6">
            <div className="card ms-5 pb-5 pt-3 rounded-lg">
              <div className="card-body ">
                <h1 className="text-center mx-auto mb-5">
                  <img src={logo} alt="logo" width={390} height={150} />
                </h1>
                <h5 className="text-center mb-4 fw-bold">
                  Choose any Cloud Service
                </h5>
                <div className="d-flex justify-content-around mb-4">
                  {cloudOptions.map((cloud) => (
                    <div>
                      <div
                        key={cloud.name}
                        className="text-center shadow"
                        onClick={() => handleSelectCloud(cloud.name)}
                        style={{
                          border:
                            selectedCloud?.name === cloud.name
                              ? "2px solid #1d62f0"
                              : "1px solid #f7f7f7",
                          padding: "10px",
                          borderRadius: "10px",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={cloud.imgSrc}
                          alt={cloud.name}
                          style={{ width: "70px", height: "70px" }}
                        />
                      </div>

                      <p className="mt-2 text-center">{cloud.name}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          aria-labelledby="modalLabel"
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="modalLabel">
                  {selectedCloud?.name} Login
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {selectedCloud && (
                  <div className="text-center mb-4">
                    <img
                      src={selectedCloud.imgSrc}
                      alt={selectedCloud.name}
                      style={{ width: "80px", height: "80px" }}
                    />
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
